module.exports = __webpack_public_path__ + "img/dwf_ch_grombrindal_0.9edd7211.png";